import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { Link } from "react-router-dom";
import { Section } from "./getJumpMenuNavItems";
import { useGetSections } from "./useGetSections";

type Props = {
  onClose: () => void;
  navigate: (path: string) => void;
  open?: boolean;
  filterText?: string;
};

export const JumpMenuNav: React.FC<Props> = ({ onClose, open, filterText }) => {
  const sections: Section[] = useGetSections(open);

  // Apply client-side filtering if filterText is provided
  const q = (filterText || "").trim().toLowerCase();
  const filteredSections = q
    ? sections
        .map((s) => {
          const items = (s.items || []).filter((it: any) => {
            const label = it.label.toLowerCase();

            const path = (it.path || "").toLowerCase();
            return label.includes(q) || path.includes(q);
          });
          return { ...s, items };
        })
        .filter((s) => (s.items || []).length > 0)
    : sections;

  return (
    <Box sx={{ p: 0 }}>
      {filteredSections.map((section) => (
        <Box key={section.titleKey} sx={{ p: 0 }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: 700, color: "text.secondary" }}
          >
            {section.label}
          </Typography>
          <List dense sx={{ p: 0, m: 0 }}>
            {section.items.map((it: any) => (
              <ListItem disablePadding key={it.key}>
                <ListItemButton
                  disabled={!!it.disabled}
                  {...(it.disabled ? {} : { component: Link, to: it.path })}
                  onClick={() => {
                    if (it.disabled) return;
                    onClose();
                  }}
                  sx={{ py: 0.25, px: 0.5 }}
                >
                  <ListItemIcon sx={{ minWidth: 32 }}>{it.icon}</ListItemIcon>
                  <ListItemText
                    primary={it.label}
                    primaryTypographyProps={{ noWrap: true, variant: "body2" }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Box sx={{ py: 0 }}>
            <Divider />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default JumpMenuNav;

